import { Button } from "@blueprintjs/core";
import { ButtonContainer, IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { AvailableJudgesApi, JudgeGridDto, PersonGridDto, ClubJudgeSearch } from "../../../../../api";
import { CustomDataTable, EmailButton } from "../../../../../components";
import { useGlobalData } from "../../../../../contexts";
import { useApiService, useTl } from "../../../../../hooks";
import { ETLCodes } from "../../../../../locales";

export interface IClubJudgeSearchPanelProps {
  onPersonSelected: (person: PersonGridDto) => void;
  clubId: number;
}

export const ClubJudgeSearchPanel: React.FunctionComponent<IClubJudgeSearchPanelProps> = ({
  clubId,
  onPersonSelected,
}) => {
  const api = useApiService(AvailableJudgesApi);
  const { currentLanguage } = useGlobalData();
  const { t } = useTl();

  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: true,
    enableFilter: true,
    availablePageSizes: [5],
    pageSize: 5,
    sortKeys: { lastName: "ASC" },
  });

  const searchFunction = React.useCallback(
    (sObj?: ClubJudgeSearch) => {
      const sobj = ClubJudgeSearch.fromJS({
        ...sObj,
        clubId: clubId,
        languageId: currentLanguage.languageId,
      });
      return api.baseSearch(sobj);
    },
    [api, clubId, currentLanguage.languageId]
  );

  const { search, loading } = useSearchApi<any, any>({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        computed: true,
        disableSorting: true,
        fieldName: "actions",
        autoFitContent: true,
        render: (row: JudgeGridDto) => (
          <ButtonContainer>
            <Button
              onClick={() => {
                onPersonSelected(row);
              }}
              text={t(ETLCodes.Select)}
            />
          </ButtonContainer>
        ),
      },
      {
        header: () => t(ETLCodes.LastName),
        fieldName: "lastName",
        render: (row: JudgeGridDto) => <>{row.name}</>,
      },
      {
        header: () => t(ETLCodes.Language),
        fieldName: "language",
      },
      {
        header: () => t(ETLCodes.Email),
        fieldName: "email",
        render: (row: JudgeGridDto) => <EmailButton email={row.email} />,
      },
      {
        header: () => t(ETLCodes.PhoneNumber),
        fieldName: "phoneNumber",
      },
      {
        header: () => t(ETLCodes.MobilePhoneNumber),
        fieldName: "mobilePhoneNumber",
      },
    ],
    [onPersonSelected, t]
  );
  React.useEffect(() => {
    search();
  }, [currentLanguage, search]);
  return <CustomDataTable tableState={tableState} loading={loading} columns={columns} />;
};
